export default __webpack_public_path__ + "static/media/bbrfaWBTC.2b31a289.png";